import { isServer } from '@frameio/utils';

export function updateUrlParams(
  update: Partial<Record<string, string | null>>,
  base?: URL
) {
  if (!base) {
    if (isServer) {
      throw new Error('updateUrlParams: base is required on the server');
    }
    // eslint-disable-next-line no-param-reassign
    base = new URL(window.location.href);
  }
  const newParams = new URLSearchParams(base.search);
  for (const [key, value] of Object.entries(update)) {
    if (value == null) {
      newParams.delete(key);
    } else {
      newParams.set(key, value);
    }
  }
  const url = new URL(base);
  url.search = newParams.toString();
  return url;
}
